module.exports = __webpack_public_path__ + "img/logo.089dc6d6.svg";